import { z } from 'zod/v4';

export const REMINDER_SENDING_MEDIA = [
  'email',
  'post',
  'registered_post',
  'missing_information',
  'ai_call',
] as const;

export type ReminderSendingMedia = (typeof REMINDER_SENDING_MEDIA)[number];

export const ReminderSendingMediaSchema = z.enum([...REMINDER_SENDING_MEDIA]);
